import { NameData } from '../types';
import { availableLetters, AvailableGender } from '../data/available-letters';

export async function loadNameData(gender: AvailableGender, letter: string): Promise<NameData[]> {
  if (!availableLetters[gender].includes(letter.toLowerCase() as any)) {
    return [];
  }

  try {
    const response = await import(`../data/${gender}/${letter.toLowerCase()}.json`);
    return response.names || [];
  } catch (error) {
    console.error(`Error loading name data for ${gender}/${letter}:`, error);
    return [];
  }
}

export async function findNameBySlug(nameSlug: string): Promise<NameData | null> {
  const genders = Object.keys(availableLetters) as AvailableGender[];

  for (const gender of genders) {
    for (const letter of availableLetters[gender]) {
      try {
        const names = await loadNameData(gender, letter);
        const foundName = names.find(
          name => formatNameSlug(name.name) === nameSlug
        );
        if (foundName) return foundName;
      } catch {
        continue;
      }
    }
  }
  return null;
}

export function formatNameSlug(name: string): string {
  return name.toLowerCase().replace(/\s+/g, '-');
}